export const colors = {
  "fp-outline": "#777680",
  "fp-outline-light": "#D3D3D3",
  "fp-outline-variant": "#B8B8B8",
  "fp-primary": "#153CC5",
  "fp-primary-hover": "#0b32bf",
  "fp-on-primary": "#FFFFFF",
  "fp-logo-color": "#4956F4",
  "fp-grey-card": "#E8E8E8",
  "fp-on-surface": "#1B1B1F",
  "fp-on-surface-variant": "#45464F",
  "fp-chat-background-grey": "#F4F3F3",
  "fp-user-chat-outline": "#B9C3D7",
  "fp-user-blue-fill": "#E1EAFD",
  "fp-suggestion-green-fill": "#e8fae9",
  "fp-neutral-grey": "#FBFBFB",
  // 'fp-neutral-grey-2': '#AAA',
  "fp-neutral-grey-2": "#c7c7c7",
  "fp-text-hint": "#727171",
  "fp-surface-1": "rgb(246,247,252)",
  "fp-text-disabled": "#1B1B1F",
  "fp-option-selected": "#D3D9E9",
  "fp-highlight": "rgba(91, 102, 255, 0.15)",
  "fp-highlight-text": "rgba(91, 102, 255, 0.3)",
  "fp-inactive-tab-grey": "#E8E8E8",
  "fp-grey-icon": "#A6A6A6",
  "fp-thumbs-up": "#20BD64",
  "fp-thumbs-down": "#EB3D40",

  // New gray palette based on the image
  gray: {
    0: "#FFFFFF",
    100: "#F5F5F5",
    200: "#E6E6E6",
    300: "#9A9A9A",
    400: "#7A7A7A",
    500: "#6A6A6A",
    600: "#454545",
    700: "#353535",
    800: "#222222",
    900: "#111827",
  },
};
